import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const CancelOutlineIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9996 14.5L10 10.5M10.0004 14.5L14 10.5M20 12.5C20 8.08172 16.4182 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9182 7.58172 20.5 12 20.5C16.4182 20.5 20 16.9182 20 12.5Z"
        stroke={iconColor}
        strokeLinecap="round"
      />
    </Box>
  );
};
